import { getEnv } from "../env";

export function isBetsson() {
    return getEnv('REACT_APP_BETSSON_VERSION') === 'true';
}
